export default __webpack_public_path__ + "media/Crowd_tablet.6aced815bc2f4734c2cf13ace606c53f.svg";